import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Button, Input, Form, Modal, Divider, Spin, message, Row, Col } from 'antd';
import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";

import LuisPage from '../../pannels/stock/LuisPage';
import SymbolGroupPage from './components/SymbolGroupPage';
import USSymbolGroupPage from './components/USSymbolGroupPage';

import emitter from '../Evt.js';

const { Content } = Layout;

const Item = ({ entity: { name, txt, char } }) => <Row><Col span={7}>{name}</Col><Col span={17}>{txt}</Col></Row>;

var timer = null;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const locale = window.appLocale.locale;
class UpdateFilterPage extends Component {
    constructor(props) {
        super(props);

        let tmpStockGroups = window.webType === 'US' ? '10000' : '3180';

        this.user = {};
        this.state = {
            stockPoolKey: 'STOCK',

            lastTimes: 0,

            caretPosition: 0,

            stockGroups: tmpStockGroups,

            filterId: 0,
            filterName: '',
            filterString: '',

            alertInterval: '400',
            state: 0,

            sourceFilterId: 0,
            validPeriodBarCount: '',
            validPeriodBarInterval: '',

            modalVisible: false,
            modalTitle: '',

            validateStatus: '',
            validateMessage: '',

            stockCount: 0,

            spinLoadding: true,

            error: '',
            filterError: '',

            textareaClass: 'common-textarea',
            alertIntervalClass: '',

            isLuisAnalysis: false,

            isSendFilter: false,

            filterRequestLoadding: false,
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendError", this.callSendError);
        emitter.addListener("callFilterRequestResult", this.callFilterRequestResult);

        this.rta.setCaretPosition(this.state.filterString.length);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendError', this.callSendError);
        emitter.removeListener('callFilterRequestResult', this.callFilterRequestResult);
    }

    callSendError = (status) => {
        this.setState({ spinLoadding: false, filterRequestLoadding: false });
    }

    callFilterRequestResult = (filterResult, filter) => {
        if (filterResult.Status === 0) {
            var filtersCache = JSON.parse(sessionStorage.getItem("FiltersCache") || '{}') || {};
            filtersCache[filterResult.FilterId] = filterResult.FilterName;
            sessionStorage.setItem("FiltersCache", JSON.stringify(filtersCache));

            var content = <span>{languageMessages['to view, please go']}"<a href="javascript:;" onClick={this.jumpMyFilter}>{languageMessages['my filter']}</a>"</span>;
            this.timerModal(languageMessages['update.filter.success'], content);
        } else {
            message.error(filterResult.Description);
        }

        this.setState({
            filterRequestLoadding: false,
            modalVisible: false,
            filterId: filterResult.FilterId,
            filterName: filterResult.FilterName,
        });
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        if (history.location.state !== undefined) {
            let fId = history.location.state.fId;

            this.props.dispatch({ type: "action_get_filter_sectors", payload: { UserId: this.user.username, stockPoolKey: this.state.stockPoolKey, stockGroups: this.state.stockGroups, fId: fId } });
        }
    }

    componentWillReceiveProps(props) {
        var { status, state, useFormulaData, filter, sourceFilter, filterGroup } = props;

        switch (status) {
            case 'luis_success':
                var stockPoolKey = 'STOCK';
                var filterId = 0;
                var filterName = '';
                var filterString = '';
                var alertInterval = '';
                var stockGroups = '';
                var state = 0;

                var sourceFilterId = 0;
                var validPeriodBarCount = '';
                var validPeriodBarInterval = '';

                if (filter !== undefined && filter !== null) {
                    filterId = filter['filterId'];
                    filterName = filter['filterName'];
                    filterString = filter['filterString'];
                    alertInterval = filter['alertInterval'];
                    stockGroups = filter['symbolGroupId'];
                    state = filter['state'];
                    
                    if (stockGroups > 0) {
                        stockPoolKey = 'CUSTOM_GROUPS';
                    }
                }
                
                if (filterGroup !== undefined && filterGroup !== null && filterGroup !== '') {
                    if (window.webType == 'US') {
                        if (filterGroup == '30000') {
                            stockPoolKey = 'FUND';
                        }
                    } else {
                        if (filterGroup == '4006' || filterGroup == '4030' || filterGroup == '4031' || filterGroup == '4032' || filterGroup == '4033' || filterGroup == '4034' || filterGroup == '4035') {
                            stockPoolKey = 'FUND';
                        }
                    }

                    stockGroups = filterGroup;
                }
                
                if (sourceFilter !== undefined && sourceFilter !== null) {
                    stockPoolKey = 'UPSTREAM_FILTER';

                    sourceFilterId = sourceFilter['sourceFilterId'];
                    validPeriodBarCount = sourceFilter['ValidPeriodBarCount'];
                    validPeriodBarInterval = sourceFilter['ValidPeriodBarInterval'];
                }

                this.setState({ spinLoadding: false, stockPoolKey, filterId, filterName, filterString, alertInterval, stockGroups, state, sourceFilterId, validPeriodBarCount, validPeriodBarInterval });
                break;
            case 'get_filter_sectors_fail':
                var error = languageMessages['get.data.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                this.setState({ spinLoadding: false });
                break;
            case 'analysis_success':
                this.setState({ isLuisAnalysis: false });
                break;
            case 'analysis_fail':
                var error = languageMessages['Intelligent.analysis.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['unable.get.intelligent.analysis.results'];
                        break;
                    case 3:
                        error = languageMessages['connection.analytics.service.failed'];
                        break;
                    case 4:
                        error = languageMessages['request.analytics.failed'];
                        break;
                    case 5:
                        error = languageMessages['user.exception'];
                        break;
                    case 6:
                        error = languageMessages['request.analysis.timeout'];
                        break;
                    default:
                        break;
                }
                message.error(error);

                this.setState({ isLuisAnalysis: false });
                break;
            case 'get_stock_count_success':
                this.setState({
                    //stockGroups: data.stockGroups,
                    //stockPoolKey: data.stockPoolKey,
                    error: '',
                    filterError: '',
                });
                break;
            case 'get_stock_count_fail':
                this.setState({
                    error: '',
                    filterError: '',
                });
                break;
            case 'clear_filter_string':
                this.setState({ filterString: '' });
                break;
            case 'use_formula':
                this.setState({
                    isLuisAnalysis: useFormulaData.isLuisAnalysis,
                    filterString: useFormulaData.filterString
                }, () => {
                    if (!useFormulaData.isLuisAnalysis) this.rta.setCaretPosition(this.state.filterString.length);
                });
                break;
            default:
                break;
        }
    }

    timerModal(title, content) {
        let secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    handleStockGroup(data) {
        this.setState({
            stockGroups: data.stockGroups,
            stockPoolKey: data.stockPoolKey,
            sourceFilterId: data.sourceFilterId,
            validPeriodBarCount: data.validPeriodBarCount,
            validPeriodBarInterval: data.validPeriodBarInterval
        }, () => {
            this.checkFilterParams();
            this.props.dispatch({ type: "action_get_stock_count", payload: { UserId: this.user.username, stockPoolKey: data.stockPoolKey, stockGroups: data.stockGroups } });
        });
    }

    handleLuisAnalysis(data) {
        this.setState({
            isLuisAnalysis: data.isLuisAnalysis
        }, () => {
            if (!data.isLuisAnalysis) this.rta.setCaretPosition(this.state.filterString.length);
        });
    }

    jumpMyFilter = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'myFilter');
        history.push({ pathname: '/mf', state: { fId: this.state.filterId } });
    }

    toMyFilter = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'myFilter');
        history.push("/mf");
    }

    onChangeInterval = (e) => {
        e.preventDefault();

        var alertInterval = e.target.value;

        this.checkInterval(alertInterval);
    }

    onBlurInterval = (e) => {
        e.preventDefault();

        var alertInterval = e.target.value;

        this.checkInterval(alertInterval);
    }

    checkInterval(alertInterval) {
        alertInterval = alertInterval.replace(/[^\d]/g, "");

        if (alertInterval.length > 0) {
            alertInterval = alertInterval.slice(0, 12);
            alertInterval = parseInt(alertInterval);

            alertInterval = alertInterval + "";
        }

        this.setState({ alertInterval }, () => {
            this.checkFilterParams();
        });
    }

    checkFilterParams() {
        let { stockPoolKey, stockGroups, filterString, alertInterval, sourceFilterId, validPeriodBarCount } = this.state;

        var error = '';
        switch (stockPoolKey) {
            case 'STOCK':
                break;
            case 'FUND':
                break;
            case 'CUSTOM_GROUPS':
                if (stockGroups === '') {
                    error = 'STOCK_GROUP_ERROR';
                }
                break;
            case 'UPSTREAM_FILTER':
                if (sourceFilterId === 0) {
                    error = 'UPSTREAM_FILTER_ERROR';
                }
                if (validPeriodBarCount === '') {
                    error = error === '' ? 'UPSTREAM_FILTER_BAR_COUNT_ERROR' : error + ',' + 'UPSTREAM_FILTER_BAR_COUNT_ERROR';
                }
                break;
            default:
                break;
        }

        var textareaClass = 'common-textarea';
        if (filterString === '') {
            textareaClass = 'common-textarea common-textarea-error';
        }

        var alertIntervalClass = '';
        if (alertInterval === '') {
            alertIntervalClass = 'has-error';
        }

        if (error === '' && textareaClass === 'common-textarea' && alertIntervalClass === '') {
            this.setState({ isSendFilter: true, error, textareaClass, alertIntervalClass });
            return true;
        } else {
            this.setState({ isSendFilter: false, error, textareaClass, alertIntervalClass });
            return false;
        }
    }

    onSaveFilter = () => {

        var state = this.checkFilterParams();
        if (!state) return;

        window._hmt && window._hmt.push(['_trackEvent', 'update filter', 'filter', 'Update filter']);

        this.setState({
            modalTitle: languageMessages['edit filter'],
            modalVisible: true,
            validateStatus: '',
            validateMessage: ''
        });
    }

    handleSaveFilter = () => {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { stockGroups, stockPoolKey, filterId, filterName, filterString, alertInterval, sourceFilterId, validPeriodBarCount, validPeriodBarInterval } = this.state;

            if (filterName === '') {
                this.setState({
                    validateStatus: 'error',
                    validateMessage: languageMessages['Filter name cannot be empty'],
                });
                return;
            }

            if (filterString.length > 8000) {
                message.error(languageMessages['strategy.content.length.too.long']);
                return;
            }

            this.setState({ filterRequestLoadding: true }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendFilter', userId: this.user.username,
                        msg: {
                            Category: 'filter',
                            Action: 'update',
                            ConceptId: 0,
                            UserId: this.user.username,
                            FilterId: filterId,
                            FilterName: filterName,
                            GroupType: stockPoolKey,
                            FilterString: filterString,
                            SymbolGroupId: stockGroups,
                            AlertInterval: alertInterval,
                            SourceFilterId: sourceFilterId,
                            ValidPeriodBarCount: validPeriodBarCount,
                            ValidPeriodBarInterval: validPeriodBarInterval,
                            State: 1
                        }
                    }
                });
            });
        }
    };

    handleCancelFilter = () => {
        this.setState({
            modalTitle: '',
            modalVisible: false,
            filterName: '',

            validateStatus: '',
            validateMessage: '',
        });
    };

    onCaretPositionChangeHandle = position => {
        this.setState({
            caretPosition: position
        });
    }

    onChangeFilterString = e => {
        this.setState({
            filterString: e.target.value,
            filterError: '',
            textareaClass: 'common-textarea',
        }, () => {
            this.checkFilterParams();
        });
    }

    buildFilterString() {
        var promise = new Promise(resolve => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                var { filterString, caretPosition } = this.state;

                var textareaValue = filterString.slice(0, caretPosition);
                var startPosition = textareaValue.search(/[A-Za-z]*$/);
                var autoMatchData = textareaValue.slice(startPosition, caretPosition);

                var dataSource = [];
                if (autoMatchData !== '') {
                    //var filterFunctionsCache = FilterFunction || [];
                    var filterFunctionsCache = JSON.parse(sessionStorage.getItem("FilterFunctionsCache") || '[]') || [];
                    if (filterFunctionsCache.length > 0) {
                        var filterFunctions = filterFunctionsCache.filter(function (e) { return e.cn.toLowerCase().indexOf(autoMatchData.toLowerCase()) !== -1; });
                        if (filterFunctions.length > 0) {
                            for (var k in filterFunctions) {
                                if (filterFunctions[k].m2 === '') continue;
                                var mouseDiscr = locale.toLowerCase() === 'en-us' ? filterFunctions[k].men : filterFunctions[k].mcn;
                                dataSource.push({
                                    key: filterFunctions[k].n,
                                    name: filterFunctions[k].cn,
                                    txt: mouseDiscr + languageMessages['example'] + filterFunctions[k].m2,
                                    char: filterFunctions[k].m2,
                                });
                            }
                        }
                    }
                }

                resolve(dataSource);
            }, 200);
        });
        return promise;
    }

    onChangeFilterName = e => {
        e.preventDefault();

        var validateStatus = '';
        var validateMessage = '';
        var filterName = e.target.value;
        if (filterName !== '') {
            filterName = filterName.slice(0, 100);

            //var pattern = /^[A-Za-z0-9_\u4e00-\u9fa5]+$/gi;
            var pattern = /^[A-Za-z0-9_]+$/gi;
            if (!pattern.test(filterName)) {
                validateStatus = 'error';
                validateMessage = languageMessages['filter.name.format'];
            }
        }
        this.setState({
            validateStatus: validateStatus,
            validateMessage: validateMessage,
            filterName: filterName
        });
    }

    clearFilterString = () => {
        if (this.props.status === 'clear_filter_string') {
            this.setState({ filterString: '' });
        } else {
            this.props.dispatch({ type: "action_clear_filterString" });
        }
    }

    render() {
        var { stockPoolKey, filterString, stockGroups } = this.state;
        var { sectors, stockCount, sourceFilter } = this.props;

        var defaultSymbolGroups = {
            stockPoolKey: stockPoolKey,
            stockGroups: stockGroups,
            sectors: sectors,
            stockCount: stockCount,
            sourceFilter: sourceFilter,
        }

        var formItemLayout = { labelCol: { xs: { span: 24 }, sm: { span: 4 }, }, wrapperCol: { xs: { span: 24 }, sm: { span: 20 }, }, };

        return (<Content className='main-container'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['vernacular keywords']} />
                <meta name="description" content={languageMessages['vernacular description']} />

                <meta property="og:title" content={languageMessages['vernacular title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['vernacular description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['vernacular title']} />
                <meta name="twitter:description" content={languageMessages['vernacular description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['edit filter']}</h1>)}
                        extra={[
                            <Button key="1" size='small' onClick={this.toMyFilter}>{languageMessages['my filter']}</Button>
                        ]} />
                    <Modal
                        title={this.state.modalTitle}
                        visible={this.state.modalVisible}
                        onOk={this.handleSaveFilter}
                        confirmLoading={this.state.filterRequestLoadding}
                        onCancel={this.handleCancelFilter}>
                        <Form {...formItemLayout}>
                            <Form.Item label={languageMessages['strategy.name.form']}
                                hasFeedback
                                validateStatus={this.state.validateStatus}
                                help={this.state.validateMessage}>
                                <Input placeholder={languageMessages['filter.name.placeholder']} id={this.state.validateStatus} value={this.state.filterName} disabled onChange={this.onChangeFilterName} />
                            </Form.Item>
                        </Form>
                    </Modal>
                </div>
                <Layout className='cont-content luis-main-content'>
                    {window.webType === 'CN' ? <SymbolGroupPage defaultSymbolGroups={defaultSymbolGroups} stockGroup={this.handleStockGroup.bind(this)} error={this.state.error} /> : <USSymbolGroupPage defaultSymbolGroups={defaultSymbolGroups} stockGroup={this.handleStockGroup.bind(this)} error={this.state.error} />}
                    <LuisPage {...this.props} filterString={filterString} isFilterScan={false} LuisAnalysis={this.handleLuisAnalysis.bind(this)} />

                    <div id="textareaAnchor" className='common-title'>
                        <Divider type="vertical" /><span>{languageMessages['formula.editing']}</span>
                        <Button size='small' onClick={this.clearFilterString} style={{ marginLeft: '20px' }}>{languageMessages['clear']}</Button>
                    </div>
                    <ReactTextareaAutocomplete rows={10} className={this.state.textareaClass}
                        value={filterString}
                        onChange={this.onChangeFilterString}
                        loadingComponent={() => <span></span>}
                        placeholder={languageMessages['use.formula.generated.or.vernacular.stock.selection']}
                        minChar={0}
                        trigger={{
                            'w': {
                                dataProvider: token => {
                                    return this.buildFilterString();
                                },
                                component: Item,
                                output: item => ({ text: item.char, caretPosition: "next" })
                            }
                        }}
                        ref={(rta) => { this.rta = rta; }}
                        onCaretPositionChange={this.onCaretPositionChangeHandle} />

                    <div style={{ padding: '10px 0' }}>
                        {'Alert interval'}
                        <span style={{ padding: '0 10px' }} className={this.state.alertIntervalClass}>
                            <Input style={{ width: 80 }} size='small' value={this.state.alertInterval} disabled onChange={this.onChangeInterval} onBlur={this.onBlurInterval} />
                        </span>
                        {'Sec'}
                    </div>

                    <div style={{ padding: '0' }}>
                        <Button size='small' onClick={this.onSaveFilter} disabled={!this.state.isSendFilter}>
                            {languageMessages['save filter']}
                        </Button>
                    </div>
                </Layout>
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.filter;
}

const page = connect(mapStateToProps)(UpdateFilterPage);
export { page as default }